(function () {
  'use strict';

  var input = document.getElementById('search-drawer-input');
  var results = document.getElementById('search-results');
  if (!input || !results) return;

  var RV_KEY = 'catchy_recently_viewed';
  var debounceTimer;

  function escHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function moneyFormat(cents) {
    return 'EGP ' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; }
    catch (e) { return []; }
  }

  function clearRecentlyViewed() {
    localStorage.removeItem(RV_KEY);
    showRecentlyViewed();
  }

  function showRecentlyViewed() {
    var list = getRecentlyViewed();
    if (!list.length) {
      results.innerHTML = '';
      return;
    }
    var html = '<div class="search-rv">';
    html += '<div class="search-rv__header"><span>RECENTLY VIEWED</span><button class="search-rv__clear" onclick="(function(){localStorage.removeItem(\'' + RV_KEY + '\');document.getElementById(\'search-results\').innerHTML=\'\';})()" type="button">CLEAR</button></div>';
    html += '<div class="search-rv__grid">';
    html += list.slice(0, 4).map(function(p) {
      return '<a href="' + p.url + '" class="search-rv__item">' +
        (p.image ? '<img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" class="search-rv__img" loading="lazy">' : '<div class="search-rv__img" style="background:var(--c-light-gray);"></div>') +
        '<div class="search-rv__info">' +
        '<div class="search-rv__title">' + escHtml(p.title) + '</div>' +
        '<div class="search-rv__price">' + escHtml(p.price || '') + '</div>' +
        '</div></a>';
    }).join('');
    html += '</div></div>';
    results.innerHTML = html;
  }

  function debounce(fn, ms) {
    return function () {
      var args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  var search = debounce(function (query) {
    if (!query || query.length < 1) {
      showRecentlyViewed();
      return;
    }

    results.innerHTML = '<div style="display:flex;justify-content:center;padding:1.5rem;"><div class="loading-spinner"></div></div>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Support both /search/suggest and /search/suggest.json response shapes
        var products = (data.resources && data.resources.results && data.resources.results.products)
          || (data.resources && Array.isArray(data.resources.results) ? data.resources.results : [])
          || [];
        if (!products.length) {
          results.innerHTML = '<p style="text-align:center;color:var(--c-dark-gray);padding:1.5rem;font-size:0.875rem;">No results for "' + escHtml(query) + '"</p>';
          return;
        }
        var html = '<div class="search-products-label">PRODUCTS</div>';
        html += '<div class="search-products-grid">';
        html += products.map(function (p) {
          var imgSrc = p.featured_image && p.featured_image.url
            ? p.featured_image.url.replace('{width}', '400')
            : '';
          var price = p.price ? moneyFormat(p.price) : '';
          var compareAt = p.compare_at_price && p.compare_at_price > p.price ? moneyFormat(p.compare_at_price) : '';
          return '<a href="' + p.url + '" class="search-result-item">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + escHtml(p.title) + '" class="search-result-item__img" width="80" height="80" loading="lazy">' : '<div class="search-result-item__img" style="background:var(--c-light-gray);"></div>') +
            '<div class="search-result-item__info">' +
            '<div class="search-result-item__title">' + escHtml(p.title) + '</div>' +
            '<div class="search-result-item__price">' +
            (compareAt ? '<s style="color:var(--c-mid-gray);margin-right:0.4rem;font-size:0.75rem;">' + compareAt + '</s>' : '') +
            price +
            '</div>' +
            '</div></a>';
        }).join('');
        html += '</div>';
        results.innerHTML = html;
      })
      .catch(function () {
        results.innerHTML = '<p style="color:var(--c-dark-gray);padding:1rem;font-size:0.875rem;">Search unavailable.</p>';
      });
  }, 220);

  input.addEventListener('input', function () { search(input.value.trim()); });

  // Show recently viewed when search opens (input gets focused)
  // focus: only show RV if results area is empty (don't override observer)
  input.addEventListener('focus', function () {
    if (!input.value.trim() && !results.innerHTML.trim()) showRecentlyViewed();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (input.value.trim()) {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(input.value.trim());
      }
    }
    if (e.key === 'ArrowDown') {
      var first = results.querySelector('a');
      if (first) first.focus();
    }
  });

  // Keyboard navigation in results
  results.addEventListener('keydown', function (e) {
    var items = Array.from(results.querySelectorAll('a'));
    var idx = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown' && idx < items.length - 1) { items[idx + 1].focus(); e.preventDefault(); }
    if (e.key === 'ArrowUp') {
      if (idx > 0) { items[idx - 1].focus(); }
      else { input.focus(); }
      e.preventDefault();
    }
  });

  // Show recently viewed when drawer opens via observer
  var searchDrawer = document.getElementById('search-drawer');
  if (searchDrawer) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.target.classList.contains('is-open') && !input.value.trim()) {
          setTimeout(function() { showRecentlyViewed(); }, 120);
        }
      });
    });
    observer.observe(searchDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Also trigger on search button clicks (mobile + desktop)
  ['header-search-btn', 'mobile-search-btn'].forEach(function(id) {
    var btn = document.getElementById(id);
    if (btn) btn.addEventListener('click', function() {
      setTimeout(function() { if (!input.value.trim()) showRecentlyViewed(); }, 100);
    });
  });
})();
